import { render, staticRenderFns } from "./RedemptionRequirements.vue?vue&type=template&id=4828ff6f&scoped=true"
import script from "./RedemptionRequirements.vue?vue&type=script&lang=js"
export * from "./RedemptionRequirements.vue?vue&type=script&lang=js"
import style0 from "./RedemptionRequirements.vue?vue&type=style&index=0&id=4828ff6f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828ff6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4828ff6f')) {
      api.createRecord('4828ff6f', component.options)
    } else {
      api.reload('4828ff6f', component.options)
    }
    module.hot.accept("./RedemptionRequirements.vue?vue&type=template&id=4828ff6f&scoped=true", function () {
      api.rerender('4828ff6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/RedemptionRequirements.vue"
export default component.exports